import licences from "@/api/licences";
import discounts from "@/api/discounts";
import { getField, updateField } from "vuex-map-fields";

export default {
    namespaced: true,
    state: {
        items: [],
        selectedItem: null,
        device: null,
        editedId: -1,
        editedItem: {
            quantity: 1,
            application_id: "",
            reseller_entity_id: "",
            price: {
                plan: "",
                type: null
            },
            discount_id: null,
            initialOptions: [],
            options: [],
            plan: null,
            type: null
        },
        defaultItem: {
            quantity: 1,
            application_id: "",
            reseller_entity_id: "",
            price: {
                plan: "",
                type: null
            },
            discount_id: null,
            initialOptions: [],
            options: [],
            plan: null,
            type: null
        },
        renewedItem: {
            price: {
                plan: "",
                type: null
            }
        },
        defaultRenewedItem: {
            price: {
                plan: "",
                type: null
            }
        },
        discounts: [],
        total: ""
    },
    getters: {
        getField,
        licencesAvailableForRenew: state => price => {
            function AreOptionsEqual(options1, options2) {
                if (
                    !(options1 instanceof Array) ||
                    !(options2 instanceof Array)
                ) {
                    return false;
                }

                return (
                    options1.length === options2.length &&
                    options1.every(
                        option1 =>
                            options2.findIndex(
                                option2 =>
                                    option1.type !== undefined &&
                                    option2.type === option1.type
                            ) !== -1
                    )
                );
            }

            return state.items.filter(
                licence =>
                    !licence.is_attached &&
                    licence.reseller_entity_id ===
                        state.selectedItem?.reseller_entity_id &&
                    licence.application_id ===
                        state.selectedItem?.application_id &&
                    licence.plan === price.plan &&
                    licence.type === price.type &&
                    (state.selectedItem.trial ||
                        AreOptionsEqual(
                            licence.options,
                            state.selectedItem?.options
                        ))
            ).length;
        },
        getLicences: state => {
            return state.items.map(x => {
                x.planType = {
                    type: x.type,
                    plan: x.plan
                };

                return x;
            });
        }
    },
    actions: {
        fetchDiscounts({ commit, rootState }) {
            return new Promise((resolve, reject) => {
                discounts
                    .indexReseller(rootState.auth.user.reseller_id)
                    .then(response => {
                        commit("setDiscounts", response.data);
                        resolve(response.data);
                    })
                    .catch(error => reject(error));
            });
        },
        fetchAll({ commit, rootState }) {
            return new Promise((resolve, reject) => {
                let fetchAllFunction = licences.indexUser(
                    rootState.auth.user.id
                );

                fetchAllFunction
                    .then(response => {
                        commit("setItems", response.data);
                        resolve(response.data);
                    })
                    .catch(error => reject(error));
            });
        },
        resetEditedItem({ commit, state }) {
            commit("setEditedId", -1);
            commit("setEditedItem", Object.assign({}, state.defaultItem));
            commit("setTotal", "");
        },
        saveEditedItem({ dispatch, state }) {
            return new Promise((resolve, reject) => {
                const options = state.editedItem.options.reduce(
                    (acc, price) => {
                        acc.push({
                            type: price.type,
                            key: price.option_key,
                            value: price.option_value,
                            amount: price.amount
                        });
                        return acc;
                    },
                    []
                );

                const data = {
                    ...state.editedItem,
                    plan: state.editedItem.price.plan,
                    type: state.editedItem.price.type,
                    options: options
                };
                licences
                    .store(state.editedItem.reseller_entity_id, data)
                    .then(response => {
                        dispatch("fetchAll");
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        },
        updateEditedItem({ dispatch, state }) {
            return new Promise((resolve, reject) => {
                const options = state.editedItem.options.reduce(
                    (acc, price) => {
                        acc.push({
                            type: price.type,
                            key: price.option_key,
                            value: price.option_value,
                            amount: price.amount
                        });
                        return acc;
                    },
                    []
                );

                const data = {
                    ...state.editedItem,
                    plan: state.editedItem.price.plan,
                    type: state.editedItem.price.type,
                    options: options
                };
                licences
                    .update(state.editedId, data)
                    .then(response => {
                        dispatch("fetchAll");
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        },
        deleteItem({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                licences
                    .delete(id)
                    .then(response => {
                        dispatch("fetchAll");
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        },
        reset({ commit, dispatch }) {
            commit("setItems", []);
            commit("setDiscounts", []);
            dispatch("resetEditedItem");
        },
        attachDevice({ dispatch, state }) {
            return new Promise((resolve, reject) => {
                licences
                    .attachDevice(state.selectedItem.id, state.device.id)
                    .then(response => {
                        dispatch("fetchAll");
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        },
        resetRenewedItem({ commit, state }) {
            commit(
                "setRenewedItem",
                Object.assign({}, state.defaultRenewedItem)
            );
        },
        renewLicence({ dispatch, state }) {
            return new Promise((resolve, reject) => {
                const data = {
                    plan: state.renewedItem.price.plan,
                    type: state.renewedItem.price.type
                };

                licences
                    .renewLicence(state.selectedItem.id, data)
                    .then(response => {
                        dispatch("resetRenewedItem");
                        dispatch("fetchAll");
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        }
    },
    mutations: {
        updateField,
        setItems(state, items) {
            state.items = items;
        },
        setEditedItem(state, item) {
            const editedItem = {
                quantity: item.quantity,
                application_id: item.application_id,
                reseller_entity_id: item.reseller_entity_id,
                price: {
                    plan: item.plan,
                    type: item.type
                },
                initialOptions: item.options,
                options: [],
                plan: item.plan,
                type: item.type
            };
            state.editedItem = editedItem;
        },
        setOptions(state, options) {
            state.editedItem.options = options.splice(0);
        },
        setEditedId(state, id) {
            state.editedId = id;
        },
        setSelectedItem(state, item) {
            state.selectedItem = Object.assign({}, item);
        },
        setDevice(state, device) {
            state.device = device;
        },
        setRenewedItem(state, item) {
            const renewedItem = {
                price: {
                    plan: item.plan,
                    type: item.type
                }
            };

            state.renewedItem = renewedItem;
        },
        setType(state, type) {
            state.renewedItem.price.type = type;
        },
        setPlan(state, plan) {
            state.renewedItem.price.plan = plan;
        },
        setDiscounts(state, items) {
            state.discounts = items;
        },
        setDiscountId(state, discountId) {
            state.editedItem.discount_id = discountId;
        },
        setTotal(state, total) {
            state.total = total;
        }
    }
};
